var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuoteLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4 29.44c6.96-4.08 13.08-10.32 13.08-18.12C16.48 3.76 11.56.28 7.36.28 3.88.28.4 3.04.4 7.36c0 3.72 3 6.24 6.48 6.24 1.08 0 2.64-.24 3.96-1.32v.84c0 .48.12 1.08.12 1.44 0 3.72-1.68 8.16-8.88 13.08l1.32 1.8zm21.6 0c6.96-4.08 13.08-10.32 13.08-18.12 0-7.56-4.92-11.04-9.12-11.04C25.48.28 22 3.04 22 7.36c0 3.72 3 6.24 6.48 6.24 1.08 0 2.64-.24 3.96-1.32v.84c0 .48.12 1.08.12 1.44 0 3.72-1.68 8.16-8.88 13.08l1.32 1.8z",
    fill: "#A28C50"
  })));
}

export default SvgQuoteLeft;